export const formatValue = (value) => {
  if (typeof value === "number" && !isNaN(value)) {
    return Number.isInteger(value) ? value : parseFloat(value.toFixed(2));
  }

  const num = Number(value);
  if (!isNaN(num)) {
    return Number.isInteger(num) ? num : parseFloat(num.toFixed(2));
  }

  return value;
};

export const getMinMaxDates = (dates) => {
  if (!Array.isArray(dates) || dates.length === 0) {
    return { minDate: null, maxDate: null };
  }

  // Convert to timestamps
  const timestamps = dates.map((d) => new Date(d).getTime());
  const minDate = new Date(Math.min(...timestamps));
  const maxDate = new Date(Math.max(...timestamps));
  return { minDate, maxDate };
};
